export type AppState = {
  /**
   * The title of this jdi_client_app_state.
   */
  title: string;
  /**
   * The locale of this jdi_client_app_state.
   */
  locale: string;
  /**
   * The breadcrumbTrail of this jdi_client_app_state.
   */
  breadcrumbTrail: string[];
  /**
   * Previous page ID
   */
  prevPage?: string;
  /**
   * Current page changed flag
   */
  pageChanged: boolean;
  /**
   * Current modal page ID
   */
  currentModalPage?: string;
  /**
   * Modal page closed callback
   */
  modalClosedCallback?: (result: any) => void;
  /**
   * Project ID
   */
  pjtId: string;
  /**
   * GOD flag
   */
  isGodMode: boolean;
  /**
   * Component Project ID
   */
  cpntPjtId: string;
  /**
   * Whether to display a success toast message on initial display
   */
  isShowSuccessToast: boolean;
};

export type AppNewState = AppState | ((prevState: AppState) => AppState);
